import { StyleSheet, Platform, Dimensions } from 'react-native';

import { Colors, Fonts, Metrics } from '@vfgroup-oneplatform/foundation/Components/Themes';

const { width: screenWidth } = Dimensions.get('window');
const titleWidht = screenWidth - 2 * Metrics.mainContentPadding;

export default StyleSheet.create({
  containerStyle: {
    backgroundColor: Colors.transparent,
    paddingHorizontal: Metrics.mainContentPadding,
  },
  fullWidth: { width: '100%' },
  iconsContainer: { height: '100%' },
  pulledArea: {
    paddingTop: Platform.OS === 'ios' ? 20 : 25,
  },
  space: { height: 30, width: 2 },
  logoAndTitleContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  titleContainerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: titleWidht - 40,
    paddingLeft: 35,
  },
  textContainer: headerTitleOpacity => ({
    width: titleWidht - 80,
    opacity: headerTitleOpacity,
  }),
  titleStyle: {
    fontSize: 22,
    textAlign: 'right',
    lineHeight: 20,
    color: Colors.white
  },
  updateContainerStyle: isVisable => ({
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    height: 30,
    opacity: isVisable ? 1 : 0,
  }),
  updateStyle: {
    fontSize: 14,
    color: Colors.light_grey,
    textAlign: 'right',
    marginHorizontal: 10,
  },
  icon: {
    marginLeft: 10,
  },
  iconOpacity: status => ({
    opacity: status === 2 ? 0.5 : 1,
  }),
  withSpace: {
    height: Platform.OS === 'ios' ? 130 : 140,
  },
  withPartialSpace: {
    height: 80,
  },
  icon_secondary: {
    tintColor: Colors.white,
  },
  closeBtn: {
    marginLeft: -20,
  },
  subtitleStyle: {
    fontSize: Platform.OS === 'ios' ? 14.6 : 14,
    fontFamily: Fonts.type.VodafoneLt,
    color: Colors.dark_grey,
    marginTop: 5,
    marginHorizontal: 10,
    textAlign: 'right',
    lineHeight: 18.7,
  },
});
